import { Dispatch, SetStateAction, createContext } from 'react';
import utils from 'utils';
import { Listing } from '../../../../../../../../../models/Listing';
import { EnquiryRoutes } from '../../utils';

type EnquiryListingContextProps = {
  listing: Listing;
  listingId: string;
  priceGuide: string;
  setClosed: () => void;
  setEnquiryRoute: Dispatch<SetStateAction<EnquiryRoutes>>;
};

export default createContext<EnquiryListingContextProps>({
  listing: null,
  listingId: '',
  priceGuide: '',
  setClosed: utils.noop,
  setEnquiryRoute: utils.noop,
});
